import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({
  theme: 'electric',
  setTheme: () => {}
});

export const useTheme = () => useContext(ThemeContext);

const themes = {
  electric: {
    name: 'Electric',
    gradient: 'from-purple-600 via-pink-600 to-blue-600',
    accent: 'from-cyan-500 to-blue-500',
    bg: 'bg-gradient-to-br from-purple-600 via-pink-600 to-blue-600'
  },
  sunset: {
    name: 'Sunset',
    gradient: 'from-orange-500 via-red-500 to-pink-500',
    accent: 'from-yellow-400 to-orange-500',
    bg: 'bg-gradient-to-br from-orange-500 via-red-500 to-pink-500'
  },
  forest: {
    name: 'Forest',
    gradient: 'from-green-600 via-teal-600 to-blue-600',
    accent: 'from-green-400 to-cyan-500',
    bg: 'bg-gradient-to-br from-green-600 via-teal-600 to-blue-600'
  },
  royal: {
    name: 'Royal',
    gradient: 'from-indigo-600 via-purple-600 to-pink-600',
    accent: 'from-yellow-400 to-pink-500',
    bg: 'bg-gradient-to-br from-indigo-600 via-purple-600 to-pink-600'
  }
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'electric';
  });

  useEffect(() => {
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};
